module.exports = __webpack_public_path__ + "img/Partner_06.04e9b6f6.png";